import { Controller } from "@hotwired/stimulus";

/**
 * Scrolls to top ONLY on actual page reload (F5 / Ctrl+R).
 *
 * Does NOT interfere with:
 * - Tab switching (visibilitychange)
 * - Turbo navigation (turbo handles its own scroll)
 * - Browser back/forward (browser restores scroll natively)
 */
export default class extends Controller {
  connect() {
    const navEntry = performance.getEntriesByType(
      "navigation"
    )[0] as PerformanceNavigationTiming;

    if (navEntry?.type === "reload") {
      window.scrollTo(0, 0);
    }
  }
}
